import { Fragment } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { SpinnerComponent } from "../../../lib/spinner";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { Calendar } from "../../../ui/molecules/calendar";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { sot } from "../../../utils";
import { GetProtDepartureExcel, setFromReportExcelDeparture, setHeadQuarterReportExcelDeparture, setToReportExcelDeparture } from "../departure/slice";
import { GetProtExcel, setFromReportExcel, setHeadQuarterReportExcel, setToReportExcel } from "../entry/slice";

interface Props {
    close: () => void;
    protType: string
}

export function DownloadExcelProt(props: Props) {
    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const departureProtocolState = useAppSelector(state => state.departureProtocol)
    const isLoading = props.protType === 'entrata'
        ? entryProtocolState.getProtExcelStatus === 'loading'
        : departureProtocolState.getProtDepartureExcelStatus === 'loading'

    return (
        <Fragment>
            <div className="bg-brandPrimary-100 p-6 flex flex-col gap-6">
                {isLoading && (
                    <div className="distinta-loading-overlay">
                        <SpinnerComponent size="medium" />
                    </div>
                )}

                <div className="grid grid-cols gap-6">
                    <MadfarmStaticSelect
                        customZIndex={9999}
                        label="Sede/Ufficio"
                        noOptionsMessage=""
                        placeholder={'Sede/Ufficio'}
                        value={props.protType === 'entrata' ? entryProtocolState.reportExcelFilters.headQuarterOffice : departureProtocolState.reportExcelFilters.headQuarterOffice}
                        defaultValue={props.protType === 'entrata' ? entryProtocolState.reportExcelFilters.headQuarterOffice : departureProtocolState.reportExcelFilters.headQuarterOffice}
                        options={sot}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            if (props.protType === 'entrata') {
                                dispatch(setHeadQuarterReportExcel(newValue))
                            }
                            else if (props.protType === 'partenza') {
                                dispatch(setHeadQuarterReportExcelDeparture(newValue))
                            }
                        }}
                    />
                </div>
                <div className="grid grid-cols-2 gap-6">
                    <Calendar
                        label="Dal"
                        selected={props.protType === 'entrata' ? entryProtocolState.reportExcelFilters.from : departureProtocolState.reportExcelFilters.from}
                        onChange={(date) => {
                            if (props.protType === 'entrata') {
                                dispatch(setFromReportExcel(date))
                            }
                            else if (props.protType === 'partenza') {
                                dispatch(setFromReportExcelDeparture(date))
                            }

                        }}
                    />
                    <Calendar
                        label="Al"
                        selected={props.protType === 'entrata' ? entryProtocolState.reportExcelFilters.to : departureProtocolState.reportExcelFilters.to}
                        onChange={(date) => {
                            if (props.protType === 'entrata') {
                                dispatch(setToReportExcel(date))
                            }
                            else if (props.protType === 'partenza') {
                                dispatch(setToReportExcelDeparture(date))
                            }

                        }}
                    />
                </div>
            </div>
            <div className="p-6 flex flex-row justify-end w-full items-center gap-2">
                <ButtonComponent
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="gray"
                    disabled={isLoading}
                    onClick={() => {
                        props.close();
                    }}
                />
                <ButtonComponent
                    size="md"
                    variant="solid"
                    iconPosition="off"
                    label="Stampa"
                    color="orange"
                    disabled={isLoading}
                    onClick={() => {
                        if (props.protType === 'entrata') {
                            dispatch(GetProtExcel(entryProtocolState.reportExcelFilters))
                        }
                        else if (props.protType === 'partenza') {
                            dispatch(GetProtDepartureExcel(departureProtocolState.reportExcelFilters))
                        }
                    }}
                />
            </div>
        </Fragment>
    )
}